import { FaseFascicolo } from './tipologiche/fase-fascicolo';

export class QuadroCompensiParcella {
  fase: FaseFascicolo;
  idFase: string;
  idCheckboxFase: string;
  checkedFase: boolean;
  idRadioMin: string;
  checkedMin: boolean;
  disabledMin: boolean;
  valoreMinimo: any;
  idRadioMed: string;
  checkedMed: boolean;
  disabledMed: boolean;
  valoreMedio: any;
  idRadioMax: string;
  checkedMax: boolean;
  disabledMax: boolean;
  valoreMassimo: any;
  compenso: any;
  nameRadio: string;
  idImporto: string;
  disabledImporto : boolean;
}
